import {
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  FLEX_ARGS,
  getDefaultValueFromMetadata,
  makeArgumentsPrivate,
  pickArgs,
} from '../../../../utils/spds/metadata';
import { STRING } from '../../../../utils/component-validations';
import { on } from '@ember/modifier';
import GhostButton from '../../action/button/ghost.gjs';
import Super from '../../core/base.gjs';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const METADATA = {
  component: 'Spds::Container::Accordion::Trigger',
  description: 'Trigger button for Accordion component',
  meta: {
    ...pickArgs(ACTION_ARGS, ['onClick']).meta,
    ...makeArgumentsPrivate(pickArgs(COMPONENT_STATE_ARGS, ['disabled', 'open'])).meta,
    gap: {
      ...FLEX_ARGS.meta.gap,
      defaultValue: '12px',
    },
    icon: {
      type: STRING,
      description: 'Icon to display in trigger',
      defaultValue: 'dropdown-caret',
    },
    justifyContent: {
      ...FLEX_ARGS.meta.justifyContent,
      defaultValue: 'flex-start',
    },
  },
  name: 'Accordion Trigger',
};

export default class SpdsContainerAccordionTrigger extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-container-accordion-trigger';
  classesToMapToArgs = ['open'];
  styles = styles;

  get expanded() {
    return `${this.args.open}`;
  }

  get gap() {
    return this.args.gap ?? getDefaultValueFromMetadata(this.constructor.metadata, 'gap');
  }

  get icon() {
    return this.args.icon ?? getDefaultValueFromMetadata(this.constructor.metadata, 'icon');
  }

  get justifyContent() {
    return (
      this.args.justifyContent ??
      getDefaultValueFromMetadata(this.constructor.metadata, 'justifyContent')
    );
  }

  <template>
    <GhostButton
      @disabled={{@disabled}}
      @gap={{this.gap}}
      @id={{this.id}}
      @justifyContent={{this.justifyContent}}
      class={{this.classes}}
      data-test-spds-container-accordion-trigger
      {{on "click" @onClick}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-controls={{@contentContainerId}}
      aria-expanded={{this.expanded}}
      ...attributes
    >
      {{svgJar
        this.icon
        class="spds-container-accordion-trigger-icon"
        data-test-spds-container-accordion-trigger-icon=""
      }}
      {{yield}}
    </GhostButton>
  </template>
}

export const ACCORDION_TRIGGER_METADATA = SpdsContainerAccordionTrigger.metadata;
